import { z } from "zod";

export const mediaTypeSchema = z.enum(["image", "video"]);
export type MediaType = z.infer<typeof mediaTypeSchema>;

export const imageConstraintsSchema = z.object({
  minPx: z.number(),
  maxPx: z.number(),
  maxAspectRatio: z.number(),
  maxBytes: z.number(),
});
export type ImageConstraints = z.infer<typeof imageConstraintsSchema>;

export const modelCapabilitiesSchema = z.object({
  supportsEndFrame: z.boolean(),
  supportsSound: z.boolean(),
  promptPlaceholderKey: z.string(),
  imageConstraints: imageConstraintsSchema.optional(),
  /** Whether the video model supports image-to-video input. Defaults to true when omitted. */
  supportsImageInput: z.boolean().optional(),
  supportedAspectRatios: z.array(z.string()).optional(),
  supportedDurations: z.array(z.number()).optional(),
  supportedResolutions: z.array(z.string()).optional(),
  maxReferenceImages: z.number().optional(),
  alwaysIncludesAudio: z.boolean().optional(),
  videoSizeMap: z.record(z.string(), z.object({
    width: z.number(),
    height: z.number(),
  })).optional(),
});
export type ModelCapabilities = z.infer<typeof modelCapabilitiesSchema>;

export const modelInfoSchema = z.object({
  id: z.string(),
  mediaType: mediaTypeSchema,
  displayName: z.string(),
  provider: z.string(),
  providerIcon: z.string().url().optional(),
  badge: z.enum(["new", "recommended"]).optional(),
  isDefault: z.boolean().optional(),
  capabilities: modelCapabilitiesSchema,
  status: z.enum(["operational", "high_demand"]).optional(),
});
export type ModelInfo = z.infer<typeof modelInfoSchema>;
